<div class="row">
  <!-- LEFT: Basket items -->
  <div class="col-lg-9 mb-3">
    <div class="card basket-main-card h-100">
      <div class="card-header basket-header">
        <div class="d-flex flex-column flex-md-row justify-content-between align-items-md-center">
          <div class="mb-2 mb-md-0">
            <h5 class="mb-1">Basket ({{ totalItems }} Items)</h5>
            <div class="text-muted fs--1">Review selected products and adjust quantities</div>
          </div>

          <div class="d-flex align-items-center">
            <a class="btn btn-sm btn-outline-secondary border-300 mr-2" routerLink="/productlist">
              <span class="fas fa-chevron-left mr-1"></span>
              Product List
            </a>

            <button class="btn btn-sm btn-primary" type="button" (click)="submitOrder()" [disabled]="basketData.length === 0">
              Submit Order
            </button>
          </div>
        </div>
      </div>

      <div class="card-body p-0" *ngIf="basketData.length > 0; else emptyBasket">

        <!-- table header -->
        <div class="basket-table-head row no-gutters align-items-center mx-0">
          <div class="col-1 text-center py-3 px-2">
            <label class="custom-check mb-0">
              <input type="checkbox"
                     [checked]="isAllSelected"
                     (change)="toggleCheckAll($event)" />
              <span class="checkmark"></span>
            </label>
          </div>

          <div class="col-7 col-md-7 py-3 px-2 px-md-3">
            Product
          </div>

          <div class="col-4 col-md-4 py-3 px-2 px-md-3 text-right">
            Qty / Price
          </div>
        </div>

        <!-- items -->
        <div class="basket-item row no-gutters align-items-center mx-0"
             *ngFor="let item of basketData; trackBy: trackByItem">

          <div class="col-1 text-center py-3 px-2">
            <label class="custom-check mb-0">
              <input type="checkbox"
                     [(ngModel)]="item.selected"
                     (ngModelChange)="onItemSelectChange()" />
              <span class="checkmark"></span>
            </label>
          </div>

          <div class="col-7 col-md-7 py-3 px-2 px-md-3">
            <div class="d-flex align-items-center basket-product-wrap">
              <div class="basket-image mr-3 d-none d-md-block">
                <img [src]="item.img"
                     [alt]="item.itemName"
                     class="img-fluid rounded basket-product-img"
                     (error)="onImageError($event)"
                     (click)="openImagePreview(item.img)" />
              </div>

              <div class="basket-product-info">
                <h6 class="mb-1 basket-product-title">{{ item.itemName }}</h6>

                <div class="basket-meta text-muted mb-1">
                  <span class="mr-2">{{ item.groupName }}</span>
                  <span class="basket-code">Code: {{ item.itemCode }}</span>
                </div>

                <a class="basket-remove-link" href="javascript:void(0)" (click)="removeItem(item.itemCode)">
                  Remove
                </a>
              </div>
            </div>
          </div>

          <div class="col-4 col-md-4 py-3 px-2 px-md-3">
            <div class="d-flex justify-content-between align-items-start flex-column flex-md-row">
              <div class="input-group input-group-sm basket-qty-group mb-2 mb-md-0">
                <div class="input-group-prepend">
                  <button class="btn btn-sm btn-outline-secondary border-300 px-2"
                          type="button"
                          (click)="decreaseQty(item)">
                    -
                  </button>
                </div>

                <input class="form-control text-center input-spin-none"
                       type="number"
                       min="1"
                       [(ngModel)]="item.orderQty"
                       (ngModelChange)="onQtyChange(item)" />

                <div class="input-group-append">
                  <button class="btn btn-sm btn-outline-secondary border-300 px-2"
                          type="button"
                          (click)="increaseQty(item)">
                    +
                  </button>
                </div>
              </div>

              <div class="basket-price text-md-right">
                {{ item.price * item.orderQty | number:'1.2-2' }} <span>₼</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ng-template #emptyBasket>
        <div class="card-body text-center py-5">
          <h5 class="mb-2">Basket is empty</h5>
          <p class="text-muted mb-3">You have no items in your basket.</p>
          <a class="btn btn-sm btn-primary" routerLink="/productlist">Go to Product List</a>
        </div>
      </ng-template>
    </div>
  </div>

  <!-- RIGHT: Summary -->
  <div class="col-lg-3 mb-3">
    <div class="card basket-summary-card sticky-summary" *ngIf="basketData.length > 0">
      <div class="card-header bg-white border-bottom-0 pb-2">
        <h5 class="mb-1">Order Summary</h5>
      </div>

      <div class="card-body pt-2">
        <div class="summary-block">
          <div class="summary-label">Selected Items</div>
          <div class="summary-value">{{ selectedTotalItems }}</div>
        </div>

        <div class="summary-block">
          <div class="summary-label">Quantity</div>
          <div class="summary-value">{{ selectedTotalQty }}</div>
        </div>

        <div class="summary-block">
          <div class="summary-total-label">Total</div>
          <div class="summary-price">{{ selectedTotalPrice | number:'1.2-2' }} ₼</div>
        </div>

        <hr>

        <div class="form-group mt-4 mb-3">
          <label class="font-weight-bold mb-2">Order Note</label>
          <textarea class="form-control summary-note"
                    rows="5"
                    placeholder="Add delivery note, request, or internal comment..."
                    [(ngModel)]="orderDescription"></textarea>
        </div>

        <button class="btn btn-primary btn-block" type="button" (click)="submitOrder()">
          Submit Order
        </button>

        <a class="btn btn-outline-secondary btn-block mt-2" routerLink="/productlist">
          Continue Shopping
        </a>
      </div>
    </div>
  </div>
</div>

<!-- IMAGE PREVIEW MODAL -->
<div class="modal fade" id="imagePreviewModal" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content bg-transparent border-0">
      <div class="text-right p-2">
        <button class="btn btn-sm btn-light" data-dismiss="modal">
          ✕
        </button>
      </div>

      <div class="text-center p-2">
        <img [src]="selectedImage"
             class="img-fluid rounded shadow"
             style="max-height: 80vh; object-fit: contain;">
      </div>
    </div>
  </div>
</div>

<!-- APPROVER MODAL -->
<div class="modal fade" id="approverModal" tabindex="-1" role="dialog" aria-labelledby="approverModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-md" role="document">
    <div class="modal-content approver-modal-content">
      <div class="modal-header border-0 pb-2">
        <div>
          <h5 class="modal-title mb-1" id="approverModalLabel">Select Approver</h5>
          <div class="text-muted small">Choose one approver before submitting the order</div>
        </div>

        <button type="button" class="close" data-dismiss="modal" aria-label="Close" [disabled]="isSubmittingOrder">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal-body pt-2">
        <div class="form-group mb-3">
          <label class="font-weight-bold mb-2">Search Approver</label>
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text bg-white border-right-0">
                <span class="fas fa-search text-muted"></span>
              </span>
            </div>

            <input #approverSearchInput
                   type="text"
                   class="form-control border-left-0"
                   placeholder="Type approver name..."
                   [(ngModel)]="approverSearchText"
                   (ngModelChange)="filterApprovers()"
                   (keydown.enter)="submitIfSingleResult()" />
          </div>
        </div>

        <div class="selected-approver-box mb-3" *ngIf="selectedApprover">
          <div class="small text-muted mb-1">Selected Approver</div>
          <div class="font-weight-bold">{{ selectedApprover.name }}</div>
        </div>

        <div class="approver-list" *ngIf="filteredApprovers.length > 0; else noApproverFound">
          <div class="approver-item"
               *ngFor="let approver of filteredApprovers"
               [class.active]="selectedApproverId === approver.id"
               (click)="selectApprover(approver)">
            <div class="d-flex align-items-center justify-content-between">
              <div class="d-flex align-items-center">
                <div class="approver-avatar mr-3">
                  {{ getApproverInitials(approver.name) }}
                </div>

                <div>
                  <div class="approver-name">{{ approver.name }}</div>
                </div>
              </div>

              <div>
                <span class="badge badge-primary" *ngIf="selectedApproverId === approver.id">Selected</span>
              </div>
            </div>
          </div>
        </div>

        <ng-template #noApproverFound>
          <div class="text-center py-4 text-muted">
            No approver found
          </div>
        </ng-template>
      </div>

      <div class="modal-footer border-0 pt-2">
        <button type="button" class="btn btn-outline-secondary" data-dismiss="modal" [disabled]="isSubmittingOrder">
          Cancel
        </button>

        <button type="button"
                class="btn btn-primary"
                [disabled]="!selectedApproverId || isSubmittingOrder"
                (click)="confirmSubmitOrder()">
          <span *ngIf="!isSubmittingOrder">
            Confirm & Submit
          </span>
          <span *ngIf="isSubmittingOrder">
            Submitting...
          </span>
        </button>
      </div>
    </div>
  </div>
</div>
